import Notification from "stimulus-notification";
Stimulus.register("notification", Notification);
